import { ObjUtils } from "../Utils/ObjUtils";
import { IpAddress } from "../Core/IpAddress";
import { Dictionary } from "../Utils/Dictionary";
import { IfEntry, IfTable } from "../InfoSets/IfTable";
import { Device } from "../Core/Device";

//export interface CdpEntryJson {
//    if_index: string;
//    device_index: string;
//    remote_ip_address: string;
//    remote_device_id: string;
//    remote_device_port: string;
//    remote_version: string;
//    remote_platform: string;
//    remote_capabilities: string;
//    remote_system_name: string;
//    remote_system_oid: string;
//    remote_location: string;
//}

// DICTIONARY KEY - for CDP entries
export class CdpEntryKey {
    public IfIndex: number;
    public DeviceIndex: string;

    constructor(ifIndex: number, deviceIndex: string) {
        this.IfIndex = ifIndex;
        if (deviceIndex != null)
            this.DeviceIndex = deviceIndex + '';
        else
            this.DeviceIndex = '';
    }

    public Equals(obj: any): boolean {
        if (obj == null)
            return false;

        if (obj == this)
            return true;

        if (!(obj instanceof CdpEntryKey))
            return false;

        var other = <CdpEntryKey>obj;

        if (other.IfIndex != this.IfIndex)
            return false;
        if (other.DeviceIndex.toLowerCase() != this.DeviceIndex.toLowerCase())
            return false;
        return true;
    }

    public GetHashCode(): number {
        return ObjUtils.GetHashCode(this.IfIndex) ^ ObjUtils.GetHashCode(this.DeviceIndex);
    }
}

export class CdpEntry /*implements ISerializable*/ {
    public IfIndex: number;
    public DeviceIndex: string;

    // REMOTE DATA
    public RemoteIpAddress: IpAddress;
    public get HasRemoteIpAddress(): boolean {
        if (this.RemoteIpAddress != null) {
            if (this.RemoteIpAddress.IsValidDiscoveryAddress)
                return true;
        }
        return false;
    }

    public RemoteDeviceId: string;
    public get HasRemoteDeviceId(): boolean {
        return !!this.RemoteDeviceId;
    }

    public RemoteDevicePort: string;
    public get HasRemoteDevicePort(): boolean {
        return !!this.RemoteDevicePort;
    }

    public RemoteVersion: string;
    public get HasRemoteVersion(): boolean {
        return !!this.RemoteVersion;
    }

    public RemotePlatform: string;
    public get HasRemotePlatform(): boolean {
        return !!this.RemotePlatform;
    }

    public RemoteCapabilities: string;
    public get HasRemoteCapabilities(): boolean {
        return !!this.RemoteCapabilities;
    }

    public RemoteSysName: string;
    public get HasRemoteSysName(): boolean {
        return !!this.RemoteSysName;
    }

    public RemoteSysOID: string;
    public get HasRemoteSysOID(): boolean {
        return !!this.RemoteSysOID;
    }

    public RemoteLocation: string;
    public get HasRemoteLocation(): boolean {
        return !!this.RemoteLocation;
    }

    public RemoteDevice: Device;
    public RemoteIfEntry: IfEntry;


    constructor(ifIndex?: number, deviceIndex?: string) {
        this.IfIndex = ifIndex;
        this.DeviceIndex = deviceIndex;

        // REMOTE DATA
        this.RemoteIpAddress = null;
        this.RemoteDeviceId = '';
        this.RemoteDevicePort = '';
        this.RemoteVersion = '';
        this.RemotePlatform = '';
        this.RemoteCapabilities = '';

        this.RemoteSysName = '';
        this.RemoteSysOID = '';
        this.RemoteLocation = '';

        this.RemoteDevice = null;
        this.RemoteIfEntry = null;
    }

    public ClearRemoteCache(): void {
        this.RemoteDevice = null;
        this.RemoteIfEntry = null;
    }

    //public Deserialize(json: CdpEntryJson): void {
    //    if (json.if_index !== undefined)
    //        this.IfIndex = parseInt(json.if_index);

    //    if (json.device_index !== undefined)
    //        this.DeviceIndex = json.device_index;

    //    if (json.remote_ip_address !== undefined)
    //        this.RemoteIpAddress = IpAddress.Create(json.remote_ip_address);

    //    if (json.remote_device_id !== undefined)
    //        this.RemoteDeviceId = json.remote_device_id;

    //    if (json.remote_device_port !== undefined)
    //        this.RemoteDevicePort = json.remote_device_port;

    //    if (json.remote_version !== undefined)
    //        this.RemoteVersion = json.remote_version;

    //    if (json.remote_platform !== undefined)
    //        this.RemotePlatform = json.remote_platform;

    //    if (json.remote_capabilities !== undefined)
    //        this.RemoteCapabilities = json.remote_capabilities;

    //    if (json.remote_system_name !== undefined)
    //        this.RemoteSysName = json.remote_system_name;

    //    if (json.remote_system_oid !== undefined)
    //        this.RemoteSysOID = json.remote_system_oid;

    //    if (json.remote_location !== undefined)
    //        this.RemoteLocation = json.remote_location;
    //}
}


export class CdpTable {
    private _cdpTable: Dictionary<CdpEntryKey, CdpEntry>;

    constructor() {
        this._cdpTable = new Dictionary<CdpEntryKey, CdpEntry>();
    }

    public Add(ifIndex: number, deviceIndex: string): CdpEntry {
        var cdpEntry: CdpEntry = null;

        var cdpKey = new CdpEntryKey(ifIndex, deviceIndex);

        if (this._cdpTable.ContainsKey(cdpKey)) {
            cdpEntry = this._cdpTable.Item(cdpKey);
        }
        else {
            cdpEntry = new CdpEntry(ifIndex, deviceIndex);
            this._cdpTable.Add(cdpKey, cdpEntry);
        }

        return cdpEntry;
	}

	public AddEntry(cdpEntry: CdpEntry): void {
		var cdpKey = new CdpEntryKey(cdpEntry.IfIndex, cdpEntry.DeviceIndex);
		this._cdpTable.Add(cdpKey, cdpEntry);
	}

    public Clear(): void {
        this._cdpTable.Clear();
    }

    public ClearRemoteCache(): void {
        this._cdpTable.ForEach((pair) => {
            pair.Value.ClearRemoteCache();
        });
    }

    public get Count(): number {
        return this._cdpTable.Count;
    }

    public Find(ifIndex: number, deviceIndex: string): CdpEntry {
        return this._cdpTable.Item(new CdpEntryKey(ifIndex, deviceIndex));
    }

    public RemoveEntry(cdpEntry: CdpEntry): boolean {
        if (cdpEntry) {
            return this._cdpTable.Remove(new CdpEntryKey(cdpEntry.IfIndex, cdpEntry.DeviceIndex));
        } else {
            return false;
        }
    }

    public Remove(ifIndex: number, deviceIndex: string): boolean {
        var cdpKey = new CdpEntryKey(ifIndex, deviceIndex);
        return this._cdpTable.Remove(cdpKey);
    }

    public ForEach(callbackfn: (value: CdpEntry, index: number, array: CdpEntry[]) => void, thisArg?: any): void {
        this._cdpTable.Values().ForEach(callbackfn, thisArg);
    }

    public Some(callbackfn: (value: CdpEntry, index: number, array: CdpEntry[]) => boolean, thisArg?: any): boolean {
        return this._cdpTable.Values().Some(callbackfn, thisArg);
    }

    public Every(callbackfn: (value: CdpEntry, index: number, array: CdpEntry[]) => boolean, thisArg?: any): boolean {
        return this._cdpTable.Values().Every(callbackfn, thisArg);
    }
}
